var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "mt-4 d-flex align-items-start justify-content-between"
        },
        [_c("back-arrow", { attrs: { title: _vm.$t("annonces.on.top") } })],
        1
      ),
      _vm._v(" "),
      _c("b-container", { staticClass: "mt-4" }, [
        _c(
          "div",
          { staticClass: "row row-cards-annonces" },
          [
            _vm.annonces && _vm.annonces.length > 0
              ? _vm._l(_vm.annonces, function(annonce) {
                  return _c(
                    "transition-group",
                    {
                      key: annonce.serverId + "annonceCard",
                      staticClass:
                        "col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4",
                      attrs: {
                        appear: "",
                        name: "listCustomTransition",
                        tag: "div"
                      }
                    },
                    [
                      _c("annonce-card-image-left", {
                        key: annonce.serverId,
                        staticClass: "cursor-pointer",
                        attrs: { annonce: annonce }
                      })
                    ],
                    1
                  )
                })
              : _c(
                  "transition-group",
                  {
                    staticClass: "col-12 empty-state-container",
                    attrs: {
                      appear: "",
                      name: "listCustomTransition",
                      tag: "div"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        key: "searchEmptyState-img",
                        staticClass: "text-center mb-4"
                      },
                      [
                        _c("img", {
                          staticClass: "empty-state-img",
                          attrs: {
                            src: require("@/assets/images/b122/img-confused.png"),
                            alt: "no result"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        key: "searchEmptyState-txt",
                        staticClass: "text-center no-result-text"
                      },
                      [
                        _c("div", { staticClass: "no-result-title mb-2" }, [
                          _vm._v(_vm._s(_vm.$t("annonce.search.emptyTitle")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "no-result-subtitle my-2" }, [
                          _vm._v(_vm._s(_vm.$t("annonce.search.emptyText")))
                        ])
                      ]
                    )
                  ]
                )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fe0f759", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fe0f759","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/TopAnnonces.vue
// module id = 8xlp
// module chunks = 0